/**
 * Shared chart drawing-area margin so Revenue / Active members / Check-ins
 * x-axes line up (WSRADM-0040 / WSRADM-0042).
 */
export const DASHBOARD_CHART_MARGIN = {
  top: 10,
  right: 10,
  bottom: 30,
  left: 96,
} as const;
